<template>
    <div class="dropdown-button" v-bind:class="[ direction, classes ]">
        <a @click.prevent="toggle" href="" v-bind:class="[toggleClasses]" class="trigger" >
            <span v-if="icon && (offIcon == '' || !show) && icon != 'OFF'" class="material-icons" v-html="icon"></span>
            <span v-if="offIcon != '' && show" class="material-icons" v-html="offIcon"></span>
            <span class="dropdown-title" v-html="title"></span>
            <span v-if="!icon" class="material-icons drop">arrow_drop_down</span>
        </a>
        <div class="dropdown-items" v-bind:class="{active:show}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {

        },
        data:function() {
            return {
                show:false
            }
        },
        props:{
            direction:{type:String,default:'left'},
            title:{type:String,default:'Menu'},
            icon:{type:String},
            classes:{type:String,default:''},
            toggleClasses:{type:String,default:'basic lighten'},
            offIcon:{type:String,default:''}
        },
        methods: {
            toggle:function() {
                this.show = this.show ? false : true;
            },
            hide:function() {
                this.show = false;
            }
        },
        mounted:function() {

        }
    }
</script>
